import yaml from 'js-yaml';
import DashboardComponentViewModel from './DashboardComponentViewModel';

export default class DashboardViewModel {
    id = null;
    name = null;
    yamlString = null;
    components = [];

    constructor(response){
        this.id = response.id;
        this.name = response.name;
        this.yamlString = response.yamlString;
        this.components = this.generateComponentObject()
    }

    // extracts the components from the yamlString.
    generateComponentObject(){
        try {
            const dashboard = yaml.load(this.yamlString);
    
            let comps = [];
            // Rebuild Components
            dashboard.components.forEach((comp) => {
                const component = new DashboardComponentViewModel(comp);
                comps.push(component);
            });

            return comps;
          } catch (e) {
            console.error('Error parsing YAML:', e);
          }
    }
}